"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isReferralEarningsTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "ReferralEarningsTransactionDetails";
};
class UserReferringProvider extends DataProvider_1.default {
    get fragments() {
        return {
            UserReferring: () => `
        ... on UserReferring {
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }          
          referrerId
          referrer {
            ${this.getFragment("UserPublicData")}
          }        
          directReferrerId
          directReferrer {
            ${this.getFragment("UserPublicData")}
          } 
          updateTime
          earningBalance
          spendingBalance
        }`,
            TransactionDetails: () => `
        ... on ReferralEarningsTransactionDetails {
          referredUserId
          referredUser {
            ${this.getFragment("UserPublicData")}
          }
        }
      `,
        };
    }
    update({ data }) {
        return this.mutate("userReferringUpdate", { data });
    }
    find({ data }, fields) {
        return this.query("userReferringsFind", { data }, this.getPageableFragment("UserReferring", fields));
    }
}
exports.UserReferringProvider = UserReferringProvider;
//# sourceMappingURL=UserReferringProvider.js.map